import { render, staticRenderFns } from "./MAM_standardReward.vue?vue&type=template&id=fef4b0ae&scoped=true&"
import script from "./MAM_standardReward.vue?vue&type=script&lang=js&"
export * from "./MAM_standardReward.vue?vue&type=script&lang=js&"
import style0 from "./MAM_standardReward.vue?vue&type=style&index=0&id=fef4b0ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef4b0ae",
  null
  
)

export default component.exports